import React from "react";

const Refund = () => {
  return (
    <div className="px-4 mx-lg-5 px-lg-5">
      <div className="px-lg-3">
        <h3 className="text-center pb-4 pt-3">
          *Refund Policy for The Elite Enterprise E-commerce Website*
        </h3>
        <p>
          <h6 className="fw-bold"> *1. Refund Eligibility:*</h6>The Elite
          Enterprise is committed to customer satisfaction. Refunds are
          processed in accordance with the terms outlined below. To be eligible
          for a refund, the item must be in its original condition and
          packaging.
        </p>
        <p>
          <h6 className="fw-bold"> *2. Return Procedure:*</h6> If you wish to
          request a refund, please contact us at &nbsp;
          <span className="fw-bold">info@theeliteenterprise.in</span> or
          <span className="fw-bold"> +91 98202 44338</span> &nbsp; within
          [number of days] days of receiving your order. Clearly state the
          reason for your refund request, and our support team will guide you
          through the return process.
        </p>
        <p>
          <h6 className="fw-bold"> *3. Damaged or Defective Items:*</h6> In the
          event that you receive a damaged or defective item, please notify us
          immediately. Provide clear images of the damaged or defective product,
          and we will initiate a return and refund process promptly.
        </p>
        <p>
          <h6 className="fw-bold"> *4. Change of Mind Returns:* </h6>If you have
          a change of mind and wish to return an item, please notify us within
          [number of days] days of receiving your order. The item must be
          unused, in its original packaging, and in resalable condition. Return
          shipping costs will be the responsibility of the customer.
        </p>
        <p>
          <h6 className="fw-bold"> *5. Refund Processing:*</h6> Refunds will be
          processed within [number of days] days of receiving the returned item.
          The refund will be issued using the original payment method. Please
          note that the time it takes for the refund to reflect in your account
          may vary depending on your bank or credit card company.
        </p>
        <p>
          <h6 className="fw-bold">*6. Non-Refundable Items:* </h6>Certain items
          are non-refundable, including but not limited to personalized or
          customized products. Please check the product description before
          making a purchase.
        </p>
        <p>
          <h6 className="fw-bold"> *7. Contact Information for Refunds:*</h6>
          <span className="fw-bold">- Email:</span>
          &nbsp;info@theeliteenterprise.in
          <br />
          <span className="fw-bold">- Phone: </span>+91 98202 44338
        </p>
        <p>
          <h6 className="fw-bold">*8. Cancellation of Orders:* </h6>If you wish
          to cancel your order, please contact us as soon as possible.
          Cancellations are subject to the status of the order and may not be
          possible once the order has been processed.
        </p>
        <p>
          <h6 className="fw-bold">*9. Updates to Refund Policy:*</h6> The Elite
          Enterprise reserves the right to update or modify this refund policy
          at any time without prior notice. Customers are encouraged to review
          this policy periodically for any changes.
          <p className="pt-2">
           
            For any inquiries or assistance regarding refunds, please contact
            our customer support using the provided contact information. The
            Elite Enterprise appreciates your trust and aims to provide a
            seamless and satisfactory shopping experience.
          </p>
        </p>
      </div>
    </div>
  );
};

export default Refund;
